/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { LABELS } from '../../../core/constants/label-constants';
import { environment } from 'environments/environment.prod';

export const defaultNavigation: FuseNavigationItem[] = [
    //Prod build route for dashboard start
    // {
    //     id: 'adminDashboards',
    //     title: LABELS.DASHBOARD,
    //     type: 'basic',
    //     icon: 'heroicons_outline:rectangle-group',
    //     link: environment.production ? '/dashboard' : '/partner/dashboard',
    //     permissions: {
    //         only: ["ADMIN", "PARTNER"]
    //     }
    // },
    //Prod build route for dashboard end
    //Staging build route for dashboard start
    {
        id: 'adminDashboards',
        title: LABELS.DASHBOARD,
        type: 'basic',
        icon: 'heroicons_outline:rectangle-group',
        link: '/dashboard',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'adminDashboards',
        title: LABELS.DASHBOARD,
        type: 'basic',
        icon: 'heroicons_outline:rectangle-group',
        link: '/partner/dashboard',
        permissions: {
            only: ["PARTNER"]
        }
    },
    //Staging build route for dashboard end
    /*{
        id: 'subAdmin',
        title: 'Sub Admin Management',
        type: 'basic',
        icon: 'supervisor_account',
        link: '/sub-admin-management',
        permissions: {
            only: ["ADMIN"]
        }
    },*/
    /*{
        id: 'client',
        title: 'Client Management',
        type: 'basic',
        icon: 'supervisor_account',
        link: '/client-management',
        permissions: {
            only: ["ADMIN"]
        }
    },*/
    {
        id: 'userList',
        title: LABELS.USER_MANAGEMENT,
        type: 'basic',
        icon: 'people',
        link: '/user-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'brandList',
        title: LABELS.BRAND_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:cube-transparent',
        link: '/master-brands',
        permissions: {
            only: ["ADMIN"]
        }
    },
    // {
    //     id: 'productList',
    //     title: LABELS.PRODUCT_MANAGEMENT,
    //     type: 'basic',
    //     icon: 'heroicons_outline:archive-box-arrow-down',
    //     link: '/partner/product-management',
    //     permissions: {
    //         only: ["PARTNER"]
    //     }
    // },
    // {
    //     id: 'productList',
    //     title: LABELS.PRODUCT_MANAGEMENT,
    //     type: 'basic',
    //     icon: 'heroicons_outline:archive-box-arrow-down',
    //     link: '/partner/partner-brands',
    //     permissions: {
    //         only: ["PARTNER"]
    //     }
    // }, 
    {
        id: 'productList',
        title: LABELS.PRODUCT_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:archive-box-arrow-down',
        link: environment.production ? '/my-product-management' : '/partner/product-management',
        permissions: {
            only: ["PARTNER"]
        }
    },
    {
        id: 'collection-management',
        title: LABELS.COLLECTION_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:circle-stack',
        link: environment.production ? '/collection-management' : '/partner/collection-management',
        permissions: {
            only: ["PARTNER"]
        }
    },
    {
        id: 'brandTermList',
        title: LABELS.BRAND_TERM_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:shield-check',
        link: '/brand-term-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'partnerList',
        title: LABELS.PARTNER_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/partner-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'styleList',
        title: LABELS.STYLE_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:adjustments-vertical',
        link: '/style-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    // {
    //     id: 'outfitList',
    //     title: LABELS.OUTFIT_MANAGEMENT,
    //     type: 'basic',
    //     icon: 'heroicons_outline:bookmark',
    //     link: '/outfit-management',
    //     permissions: {
    //         only: ["ADMIN"]
    //     }
    // },
    // {
    //     id: 'wardrobe-category-List',
    //     title: LABELS.WARDROBE_CATEGORY_MANAGEMENT,
    //     type: 'basic',
    //     icon: 'heroicons_outline:table-cells',
    //     link: '/wardrobe-category-management',
    //     permissions: {
    //         only: ["ADMIN"]
    //     }
    // },
    {
        id: 'season-List',
        title: LABELS.SEASON_MANAGEMENT,
        type: 'basic',
        icon: 'wb_sunny',
        link: '/season-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'occasion-List',
        title: LABELS.OCCASION_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:calendar-days',
        link: '/occasion-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'advertise-management',
        title: LABELS.ADVERTISE_MANAGEMENT,
        type: 'basic',
        icon: 'ondemand_video',
        link: '/advertise-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'prompt-management',
        title: LABELS.PROMPT_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-bottom-center-text',
        link: '/prompt-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'marketplace-management',
        title: LABELS.MARKETPLACE_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:bookmark-square',
        link: '/vintage-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'order-management',
        title: LABELS.ORDER_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: '/order-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'order-management',
        title: LABELS.ORDER_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: environment.production ? '/order-management' : '/partner/order-management',
        permissions: {
            only: ["PARTNER"]
        }
    },
    {
        id: 'return-management',
        title: LABELS.RETURN_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: '/return-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'return-management',
        title: LABELS.RETURN_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: environment.production ? '/return-management' : '/partner/return-management',
        permissions: {
            only: ["PARTNER"]
        }
    },
    {
        id: 'inventory-management',
        title: LABELS.INVENTORY_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: environment.production ? '/inventory-management' : '/partner/inventory-management',
        permissions: {
            only: ["PARTNER"]
        }
    },
    // {
    //     id: 'adminDashboards',
    //     title: LABELS.MY_ACCOUNT,
    //     type: 'basic',
    //     icon: 'heroicons_outline:rectangle-group',
    //     link: '/partner/my-account',
    //     permissions: {
    //         only: ["PARTNER"]
    //     }
    // },

    {
        id: 'report-management',
        title: LABELS.REPORT_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/report-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'report-content-management',
        title: LABELS.REPORT_CONTENT_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/report-content-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'ai-cost-management',
        title: LABELS.AI_COST,
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/ai-cost-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'promo-code-management',
        title: LABELS.PROMO_CODE_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: '/promo-code-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    // {
    //     id: 'shipping-cost-matrix',
    //     title: LABELS.SHIPPING_COST_MATRIX,
    //     type: 'basic',
    //     icon: 'heroicons_outline:arrows-pointing-in',
    //     link: environment.production ? '/shipping-cost-matrix' : '/partner/shipping-cost-matrix',
    //     permissions: {
    //         only: ["ADMIN", "PARTNER"]
    //     }
    // },
    {
        id: 'shipping-cost-matrix',
        title: LABELS.SHIPPING_COST_MATRIX,
        type: 'basic',
        icon: 'heroicons_outline:arrows-pointing-in',
        link: '/shipping-cost-matrix',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'shipping-cost-matrix',
        title: LABELS.SHIPPING_COST_MATRIX,
        type: 'basic',
        icon: 'heroicons_outline:arrows-pointing-in',
        link: '/partner/shipping-cost-matrix',
        permissions: {
            only: ["PARTNER"]
        }
    },
    {
        id: 'notification-management',
        title: LABELS.NOTIFICATION_MANAGEMENT,
        type: 'basic',
        icon: 'heroicons_outline:bell',
        link: '/notification-management',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'adminDashboards',
        title: LABELS.MY_ACCOUNT,
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: environment.production ? '/my-profile' : '/partner/my-profile',
        permissions: {
            only: ["PARTNER"]
        }
    },
    {
        id: 'configuration',
        title: LABELS.CONFIGURATION,
        type: 'basic',
        icon: 'heroicons_outline:bookmark-square',
        link: '/configuration',
        permissions: {
            only: ["ADMIN"]
        }
    },
    {
        id: 'contentManagement',
        title: LABELS.CONTENT_MANAGEMENT,
        type: 'collapsable',
        icon: 'heroicons_outline:cog',
        children: [
            {
                id: 'privacy-policy',
                title: LABELS.PRIVACY_POLICY,
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/content-management/privacy-policy',
            },
            {
                id: 'terms-and-conditions',
                title: LABELS.TERMS_AND_CONDITIONS,
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/content-management/terms-and-conditions',
            },
            {
                id: 'cookie-policy',
                title: LABELS.COOKIE_POLICY,
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/content-management/cookie-policy',
            },
        ],
        permissions: {
            only: ["ADMIN"]
        }
    },
    /*{
        id: '404',
        title: '404',
        type: 'basic',
        icon: 'heroicons_outline:face-frown',
        link: '404',
        permissions: {
            only: ["CLIENT"]
        }
    },
    {
        id: 'maintenance',
        title: 'Maintenance',
        type: 'basic',
        icon: 'heroicons_outline:exclamation-triangle',
        link: 'maintenance',
        permissions: {
            only: ["ADMIN"]
        }

    }*/
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
        permissions: {
            only: [],
            except: []
        }
    },

];
export const futuristicNavigation: FuseNavigationItem[] = [

    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
        permissions: {
            only: [],
            except: []
        }
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
        permissions: {
            only: [],
            except: []
        }
    }
];
